"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unaccent = exports.transformToFilterExpression = void 0;
const _ = __importStar(require("lodash"));
const parser_1 = require("./parser");
const types_1 = require("./types");
function esc(value) {
    if (_.isString(value)) {
        return value.replace(/\'/g, "\\'");
    }
    return value;
}
function transformToFilterExpression(input) {
    if (!(0, parser_1.isGettextExpression)(input)) {
        throw new TypeError(`Not a valid gettext expression: ${input}`);
    }
    const parsed = (0, parser_1.parseGettextExpression)(input);
    switch (parsed.kind) {
        case types_1.GettextKind.gettext:
            return `'${esc(parsed.msgid)}'|gettext`;
        case types_1.GettextKind.pgettext:
            return `'${esc(parsed.msgid)}'|pgettext('${esc(parsed.context)}')`;
        case types_1.GettextKind.ngettext:
            return `'${esc(parsed.msgid)}'|ngettext(${parsed.n})`;
        case types_1.GettextKind.npgettext:
            return `'${esc(parsed.msgid)}'|npgettext('${esc(parsed.context)}', ${parsed.n})`;
        default:
            return input;
    }
}
exports.transformToFilterExpression = transformToFilterExpression;
function unaccent(value) {
    if (_.isString(value)) {
        return value.normalize('NFD').replace(/\p{Diacritic}/gu, '');
    }
    return value;
}
exports.unaccent = unaccent;
//# sourceMappingURL=transform.js.map